import { useState } from 'react';
import { TIP_FAQS } from '@/mocks/faqs';
import SectionHeading from './SectionHeading';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <SectionHeading
              index="05"
              kicker="常见问题"
              title="关于爆料征集，你常问的都在这里"
              sub="身份、采纳标准、证据上传与反馈节奏，先看一眼再提交，能帮你把料准备得更完整。"
            />
          </div>

          <div className="lg:col-span-12">
            <div className="mt-2 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-10">
              {/* accordion list */}
              <div className="lg:col-span-8">
                <div className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-100/60 px-5 md:px-6">
                  {TIP_FAQS.map((f, i) => {
                    const open = openIdx === i;
                    return (
                      <div key={f.q}>
                        <button
                          type="button"
                          onClick={() => setOpenIdx(open ? null : i)}
                          aria-expanded={open}
                          className="flex w-full items-center justify-between gap-4 py-5 text-left"
                        >
                          <span className="flex items-start gap-3">
                            <span
                              className={
                                'mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full font-heading text-[13px] font-bold ' +
                                (open ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600')
                              }
                            >
                              {String(i + 1).padStart(2, '0')}
                            </span>
                            <span className="font-heading text-[15px] font-bold text-foreground-900 md:text-base">
                              {f.q}
                            </span>
                          </span>
                          <i
                            className={
                              'shrink-0 text-xl text-foreground-500 transition-transform ' +
                              (open ? 'ri-subtract-line rotate-0 text-primary-600' : 'ri-add-line')
                            }
                            aria-hidden="true"
                          ></i>
                        </button>
                        {open && (
                          <div className="pb-6 pl-10">
                            <p className="border-l-2 border-primary-300 pl-4 text-[14px] leading-relaxed text-foreground-600 md:text-[15px]">
                              {f.a}
                            </p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* side prompt */}
              <aside className="lg:col-span-4">
                <div className="rounded-lg border border-primary-200 bg-primary-100/70 p-6 md:p-7">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-question-answer-line text-xl" aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-primary-900">还有疑问？直接问编辑</h3>
                  <p className="mt-2 text-[14px] leading-relaxed text-primary-950/80">
                    没被问到的问题，往往是最有价值的料。你可以在提供线索时附上一句补充说明，我们逐条回复。
                  </p>
                  <a
                    href="#submit"
                    className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-900"
                  >
                    去提交线索
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}